import { useState } from "react";
import { Link } from "react-router-dom";
import { Check, Copy, MessageCircle, Facebook, ImageDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { track } from "@/lib/engagement";
import { founderStoryBlob } from "@/lib/founderImage";

export const FOUNDER_DISCLAIMER = "Riconoscimento simbolico e gratuito: l'accesso prioritario e in anteprima alle novità è offerto quando disponibile e non dà diritto a premi, denaro o vantaggi garantiti.";

const shareUrl = () => `${window.location.origin}/founder`;
const shareText = "Sono Founder Readoo, tra i primi lettori di Readoo: le notizie importanti del giorno e le novità in anteprima. Unisciti anche tu";

const BTN = "inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full border border-hair bg-surface text-xs font-semibold text-onSurface hover:border-brand hover:text-brand transition-colors disabled:opacity-50";

function StoryImageButton({ name }) {
  const [busy, setBusy] = useState(false);
  const make = async () => {
    setBusy(true);
    try {
      const blob = await founderStoryBlob(name);
      const file = new File([blob], "founder-readoo.png", { type: "image/png" });
      track("founder_shared_image");
      if (navigator.canShare?.({ files: [file] })) {
        await navigator.share({ files: [file], text: `${shareText}: ${shareUrl()}` }).catch(() => {});
      } else {
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob); a.download = file.name; a.click();
        setTimeout(() => URL.revokeObjectURL(a.href), 2000);
        toast.success("Immagine scaricata: pubblicala nelle tue storie");
      }
    } catch { toast.error("Non è stato possibile creare l'immagine"); } finally { setBusy(false); }
  };
  return (
    <button type="button" data-testid="founder-share-image" className={BTN} onClick={make} disabled={busy}>
      {busy ? <Loader2 size={14} className="animate-spin" /> : <ImageDown size={14} />} Immagine per le storie
    </button>
  );
}

export function FounderShare({ name }) {
  const [copied, setCopied] = useState(false);
  const open = (channel, url) => { track(`founder_shared_${channel}`); window.open(url, "_blank", "noopener,noreferrer"); };
  const copy = async () => {
    try { await navigator.clipboard.writeText(`${shareText}: ${shareUrl()}`); } catch { return; }
    track("founder_shared_link");
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const u = encodeURIComponent(shareUrl());
  return (
    <div data-testid="founder-share" className="mt-3">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-xs text-subtle mr-1">Condividi:</span>
        <button type="button" data-testid="founder-share-whatsapp" className={BTN}
          onClick={() => open("whatsapp", `https://wa.me/?text=${encodeURIComponent(`${shareText}: ${shareUrl()}`)}`)}>
          <MessageCircle size={14} /> WhatsApp
        </button>
        <button type="button" data-testid="founder-share-facebook" className={BTN}
          onClick={() => open("facebook", `https://www.facebook.com/sharer/sharer.php?u=${u}`)}>
          <Facebook size={14} /> Facebook
        </button>
        <button type="button" data-testid="founder-share-copy" className={BTN} onClick={copy}>
          {copied ? <><Check size={14} /> Link copiato</> : <><Copy size={14} /> Copia link</>}
        </button>
        <StoryImageButton name={name} />
      </div>
      <p data-testid="founder-disclaimer" className="mt-2 text-[11px] text-subtle">
        {FOUNDER_DISCLAIMER} <Link to="/termini#founder" data-testid="founder-terms-link" className="underline hover:text-brand">Termini</Link>
      </p>
    </div>
  );
}
